import { useGateway } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';
import { ModuleCampaign } from '@modules/remotes/campaign';
import type { MfCampaignAppConfig } from './Campaign.types';

function ViewsCampaigns({ mode }: Readonly<{ mode: string }>) {
  const appConfig = getAppConfig();
  const gateway = useGateway();

  const campaignAppConfig: MfCampaignAppConfig = {
    API_ROOT: appConfig.API_ROOT,
    CREATIVE_BUILDS_URL: appConfig.CREATIVE_BUILDS_URL,
    CREATIVE_MANIFEST_URL: appConfig.CREATIVE_MANIFEST_URL,
    DOWNLOAD_URL: appConfig.DOWNLOAD_URL,
    EXPORT_URL: appConfig.EXPORT_URL,
    FILE_URL: appConfig.FILE_URL,
    IMG_URL: appConfig.IMG_URL,
    KEYCLOAK_CLIENT_ID: appConfig.KEYCLOAK_CLIENT_ID,
    KEYCLOAK_REALM: appConfig.KEYCLOAK_REALM,
    KEYCLOAK_URL: appConfig.KEYCLOAK_URL,
    MAPBOX_TOKEN: appConfig.MAPBOX_TOKEN,
    MAPBOX_URL: appConfig.MAPBOX_URL,
    MF_REMOTE_ADCREATOR_URL: appConfig.MF_REMOTE_ADCREATOR_URL,
    MF_REMOTE_BOOKING_URL: appConfig.MF_REMOTE_BOOKING_URL,
    MF_REMOTE_MAP_URL: appConfig.MF_REMOTE_MAP_URL,
    MF_REMOTE_TARGETING_URL: appConfig.MF_REMOTE_TARGETING_URL,
    MF_REMOTE_PREVIEW_URL: appConfig.MF_REMOTE_PREVIEW_URL,
    MF_REMOTE_REPORTING_URL: appConfig.MF_REMOTE_REPORTING_URL,
    ORG_ID: appConfig.ORG_ID,
    PREVIEW_F11_HOST: appConfig.PREVIEW_F11_HOST,
    PREVIEW_NEUTRAL_HOST: appConfig.PREVIEW_NEUTRAL_HOST,
    STAGE_HOST_LIVE: appConfig.STAGE_HOST_LIVE,
    STAGE_HOST_PREVIEW: appConfig.STAGE_HOST_PREVIEW,
    SUPPORTED_LANGUAGES: appConfig.SUPPORTED_LANGUAGES,
    THEME_DEFAULT: appConfig.THEME_DEFAULT,
    THEME_URL: appConfig.THEME_URL,
  };

  return (
    <ModuleCampaign
      mode={mode}
      gateway={gateway}
      appConfig={campaignAppConfig}
    />
  );
}

export default ViewsCampaigns;
